import { createFileRoute } from '@tanstack/react-router'
import { OutboundWebhooks } from '@/components/webhooks/OutboundWebhooks'

export const Route = createFileRoute('/_app/settings/webhooks/outbound')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="space-y-6 pt-6">
      <OutboundWebhooks />
    </div>
  )
}
